import { useApolloClient } from '@apollo/client'
import { navigate } from 'gatsby'

import { Search } from '@karakuri-web/faq-component'
import { SearchLayout } from '@karakuri-web/faq-type'

import { EventTrigger } from '../utils/event-trigger'

import { GQL_SEARCHED_FAQ, GQL_SEARCH_FAQ } from './graphql'
import { Data } from './interface'

interface Props {
  data: Data
  layout: SearchLayout
}
export function SearchWidget({ layout, data }: Props) {
  const client = useApolloClient()
  const botId = data.settingYaml.botId
  const tenantId = data.settingYaml.tenantId

  const handleSearched = (inputValue: string, result: any[]) => {
    EventTrigger.search(inputValue, result)
    client.mutate({
      mutation: GQL_SEARCHED_FAQ,
      variables: {
        botId,
        tenantId,
        text: inputValue,
      },
    })
  }

  return (
    <div className="faq-panel faq-panel-search">
      <h3 className="faq-panel-title">{layout.title || 'キーワード検索'}</h3>
      <Search
        onClick={navigate}
        onSearched={handleSearched}
        searchWaitMs={data.settingYaml.waitMs?.search ?? 5000}
        search={inputValue => {
          return client.query({
            query: GQL_SEARCH_FAQ,
            variables: {
              botId,
              tenantId,
              inputValue: inputValue || '',
              searchType: data.settingYaml.searchType,
            },
          })
        }}
        resultMessage={{
          success: data.settingYaml.words?.search?.resultMessage?.success || undefined,
          error: data.settingYaml.words?.search?.resultMessage?.error || undefined,
        }}
      />
    </div>
  )
}
